import React from "react";
import {
    HoursOutterWrapper,
    HourColumnOne,
    HourColumnTwo,
    HoursTitle,
} from "./StyledComponents";
import Clock from "../../assets/SVGComponents/Clock";
import formatPhoneNumber from "../../assets/store/formatPhoneNumber";
import { formatText } from "../../assets/store/formatText";

const MapSectionHoursBlock = ({
    isMobile,
    hoursBlockStyles,
    rowData,
    phoneNumber,
    hours,
    hoursLabel,
    className,
}) => {
    const { border_radius, border_color, text_transform } = hoursBlockStyles;
    return (
        <HoursOutterWrapper
            mobile={isMobile}
            borderRadius={border_radius}
            borderColor={border_color}
            className={className}
        >
            <HoursTitle style={{}}>
                <Clock
                    fill={"#9f9f9f"}
                    svgIconSize={isMobile ? "15px" : "20px"}
                    styles={{
                        paddingRight: isMobile ? "10px" : "20px",
                        boxSizing: "unset",
                    }}
                />
                <div
                    className={`FOD${hoursLabel.replaceAll(' ', '')}Title`}
                    style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        textTransform: text_transform,
                    }}
                >
                    {formatText(rowData, hoursLabel)}
                </div>
                {phoneNumber ? (
                    <span style={{ marginLeft: "10px" }}>
                        {" "}
                        {formatPhoneNumber(phoneNumber)}
                    </span>
                ) : null}
            </HoursTitle>
            {Object.keys(hours).map((key) => {
                return (
                    <React.Fragment key={"service-hours-" + key}>
                        <HourColumnOne
                            textTransform={text_transform}
                            className={"service-hours-column-1"}
                        >
                            {formatText(rowData, key, false)}
                        </HourColumnOne>
                        <HourColumnTwo
                            closed={hours[key] === "Closed"}
                            textTransform={text_transform}
                            className={
                                "service-hours-column-2" +
                                (hours[key] === "Closed" ? "-closed" : "")
                            }
                        >
                            {formatText(rowData, hours[key], false)}
                        </HourColumnTwo>
                    </React.Fragment>
                );
            })}
        </HoursOutterWrapper>
    );
};

export default MapSectionHoursBlock;
